import { render } from "./ErrorComponent.vue?vue&type=template&id=81e6ba6c&ts=true"
import script from "./ErrorComponent.vue?vue&type=script&lang=ts"
export * from "./ErrorComponent.vue?vue&type=script&lang=ts"

import "./ErrorComponent.vue?vue&type=style&index=0&id=81e6ba6c&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__